import type React from 'react';

interface StatCardProps {
  children: React.ReactNode;
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({ children, className }) => (
  <div className={`bg-white shadow p-4 flex items-center justify-between rounded-[var(--dashboard-radius)!important] ${className ?? ''}`}>
    {children}
  </div>
);

export default StatCard;
